/*
 * @Author: Json Chen
 * @Date: 2021-07-01 10:07:09
 * @LastEditTime: 2022-06-13 15:12:59
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLanguage/Components/ShopperTransSettings.tsx
 */
import Selector from '@/src/components/TableColSelector/ColSelector';
import { useCreation, useDebounceFn } from 'ahooks';
import { Col, Input, Row, Spin, Tabs } from 'antd';
import _ from 'lodash';
import React from 'react';
import { useParams } from 'react-router';
import Query from 'src/constrains/Query/Query';
import { getBaseUrl } from 'src/tools/server';
import styles from '../style.module.less';
import ActionButtons from './ActionButtons';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const DebounceInput = ({ value, onChange, ...props }: any) => {
  const initValue = useCreation(() => value, []);
  const [_value, _setValue] = React.useState(value);
  const { run } = useDebounceFn(
    () => {
      onChange(_value);
    },
    {
      wait: 1000,
    },
  );
  const resetInputValue = () => {
    if (!_value.trim()) {
      onChange(initValue);
      _setValue(initValue);
    }
  };

  React.useEffect(() => {
    _setValue(value);
  }, [value]);

  return (
    <Input
      {...props}
      value={_value}
      onBlur={resetInputValue}
      onChange={(e) => {
        _setValue(e.target.value);
        run();
      }}
    />
  );
};

const ShopperTransSettings = ({
  value: shopperTransSettings = [],
  onChange,
  onImportEnd,
  defaultTransSetting,
  disableEdit,
}: any) => {
  if (!shopperTransSettings.length || !defaultTransSetting) {
    return null;
  }
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { uuid } = useParams<{ uuid: string }>();

  const list = [defaultTransSetting].concat(shopperTransSettings);
  // 拿到所有的tab切换的标签,所有数据的item的categories 都一样的
  const categories = defaultTransSetting.categories || [];
  const [loading, setLoading] = React.useState<boolean>(false);

  const [currentTab, setCurrentTab] = React.useState<number>(0);
  const [searchList, setSearchList] = React.useState<string[]>([]);

  const [allColumns, setAllColumns] = React.useState([]);

  React.useEffect(() => {
    setAllColumns(
      shopperTransSettings.map((item, index) => ({
        key: index,
        title: `${item.locale}${
          index === 0
            ? ` (${getI18n('salesChannelLanguage.index.primaryLanguage')})`
            : ''
        }`,
        optional: true,
        default: allColumns[index] ? allColumns[index].default : true,
      })),
    );
  }, [shopperTransSettings]);

  // { [subCategories.index ]:[keys.index,keys.index,keys.index] }
  const searchShowIndex = React.useMemo(() => {
    let _searchShowIndex = null;
    if (searchList.length) {
      const subCategories =
        defaultTransSetting.categories[currentTab].subCategories;

      for (let a = 0; a < subCategories.length; a++) {
        const keys = subCategories[a].keys;
        for (let b = 0; b < (keys || []).length; b++) {
          if (
            searchList.every((s) =>
              (keys[b].value || '')
                .trim()
                .toLowerCase()
                .includes(s.toLowerCase()),
            )
          ) {
            if (_searchShowIndex) {
              if (_searchShowIndex[a]) {
                _searchShowIndex[a].push(b);
              } else {
                _searchShowIndex[a] = [b];
              }
            } else {
              _searchShowIndex = {
                [a]: [b],
              };
            }
            // _searchShowIndex.push([a, b]);
          }
        }
      }
    }

    return _searchShowIndex;
  }, [searchList, currentTab]);

  const onTabClick = () => {
    setLoading(true);
  };

  const onSelecterReset = () => {
    setAllColumns(
      allColumns.map((item) => ({
        ...item,
        default: true,
      })),
    );
  };
  const onTabsChange = (active) => {
    setCurrentTab(active);
    setLoading(false);
  };

  const onSearch = (values) => {
    setSearchList(searchList.concat(values.trim()));
  };
  const onTagClose = (index) => {
    setSearchList(searchList.filter((_, i) => i !== index));
  };

  const onInputChange = ({
    shopperTransSettingIndex,
    categoryIndex,
    subCategoryIndex,
    keyIndex,
    value,
  }: any) => {
    const newShopperTransSettings = _.cloneDeep(shopperTransSettings);
    newShopperTransSettings[shopperTransSettingIndex].categories[
      categoryIndex
    ].subCategories[subCategoryIndex].keys[keyIndex].value = value;
    onChange(newShopperTransSettings);
  };

  return (
    <>
      <Tabs
        className={styles.tabsContainer}
        defaultActiveKey={'0'}
        size='large'
        style={{ marginBottom: 32 }}
        onTabClick={onTabClick}
        onChange={onTabsChange}>
        {categories.map((category, categoryIndex) => {
          return (
            <Tabs.TabPane
              tab={category.name}
              key={categoryIndex}
              className={styles.tabPane}></Tabs.TabPane>
          );
        })}
      </Tabs>

      <div className={styles.operating}>
        <div className={styles.searchContainer}>
          <Query
            className={styles.search}
            searchList={searchList}
            onSearch={onSearch}
            onTagClose={onTagClose}
            onPress={onSearch}
          />
        </div>
        <div className={styles.actions}>
          <ActionButtons
            updatePage={onImportEnd}
            downloadUrl={`${getBaseUrl()}portal/salesChannelSetting/languageSetting/export/${uuid}/CSV`}
            uploadUrl={`portal/salesChannelSetting/languageSetting/import/${uuid}`}
            downloadText={getI18n('salesChannelLanguage.index.translationfile')}
            disableImport={disableEdit}
            disableExport={disableEdit}
          />
        </div>
      </div>

      <div className={styles.selector}>
        <Selector
          allColumns={allColumns}
          onChange={setAllColumns}
          setReset={onSelecterReset}
        />
      </div>

      <Spin spinning={loading}>
        <Row className={styles.tableWrap}>
          {list.map((transItem, transItemIndex) => {
            if (
              transItemIndex !== 0 &&
              allColumns[transItemIndex - 1] &&
              !allColumns[transItemIndex - 1].default
            ) {
              return null;
            }

            let text = '';
            switch (transItemIndex) {
              case 0:
                text = `${getI18n(
                  'salesChannelLanguage.index.default',
                )} (${getI18n('salesChannelLanguage.index.primaryLanguage')})`;
                break;
              case 1:
                text = `${transItem.locale} (${getI18n(
                  'salesChannelLanguage.index.primaryLanguage',
                )})`;
                break;

              default:
                text = transItem.locale;
                break;
            }

            return !searchShowIndex && searchList.length ? (
              !transItemIndex ? (
                <div key={transItemIndex} className={styles.noResult}>
                  <div className={styles.noResultTitle}>
                    {getI18n('salesChannelLanguage.index.nosearchresult')}
                  </div>
                  <div className={styles.noResultDescription}>
                    {getI18n('salesChannelLanguage.index.tryanotherkeyword')}
                  </div>
                </div>
              ) : null
            ) : (
              <Col
                flex={1}
                key={transItemIndex}
                className={styles.tableItem}
                span={12}>
                {/* table的header 部分 */}
                <div className={styles.tableHeader}>{text}</div>
                <Row className={styles.tableSubItemWrapper}>
                  {(
                    (transItem.categories[currentTab] || {}).subCategories || []
                  ).map((subCategory, subCategoryIndex) => {
                    if (searchShowIndex) {
                      if (!searchShowIndex[subCategoryIndex]) {
                        return null;
                      }
                    }
                    return (
                      <Col
                        className={styles.tableSubItem}
                        key={subCategoryIndex}>
                        <Row className={styles.tableSubItemTitle}>
                          {transItemIndex === 0 ? subCategory.name : ''}
                        </Row>
                        <Row className={styles.tableInputItemWrapper}>
                          {(subCategory.keys || []).map((key, keyIndex) => {
                            if (searchShowIndex) {
                              if (
                                !searchShowIndex[subCategoryIndex] ||
                                !searchShowIndex[subCategoryIndex].includes(
                                  keyIndex,
                                )
                              ) {
                                return null;
                              }
                            }
                            return (
                              <Col
                                key={keyIndex}
                                className={styles.tableInputItem}>
                                <Row className={styles.tableInputItemTitle}>
                                  {transItemIndex === 0 ? key.description : ''}
                                </Row>
                                <Row
                                  className={
                                    styles.tableInputItemInputContainer
                                  }>
                                  {transItemIndex === 0 ? (
                                    <div className={styles.formItem}>
                                      <DebounceInput
                                        value={key.value}
                                        disabled={true}
                                      />
                                    </div>
                                  ) : (
                                    <div className={styles.formItem}>
                                      <DebounceInput
                                        value={key.value}
                                        disabled={disableEdit}
                                        onChange={(v) => {
                                          onInputChange({
                                            shopperTransSettings,
                                            shopperTransSettingIndex:
                                              transItemIndex - 1,
                                            categoryIndex: currentTab,
                                            subCategoryIndex: subCategoryIndex,
                                            keyIndex: keyIndex,
                                            value: v,
                                          });
                                        }}
                                      />
                                    </div>
                                    // <Form.Item
                                    //   name={[
                                    //     'shopperTransSettings',
                                    //     transItemIndex - 1,
                                    //     'categories',
                                    //     currentTab,
                                    //     'subCategories',
                                    //     subCategoryIndex,
                                    //     'keys',
                                    //     keyIndex,
                                    //     'value',
                                    //   ]}>
                                    //   <DebounceInput />
                                    // </Form.Item>
                                  )}
                                </Row>
                              </Col>
                            );
                          })}
                        </Row>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            );
          })}
        </Row>
      </Spin>
    </>
  );
};

export default ShopperTransSettings;
